function isDateValidFormat(date) {
  // Assumes date format is "mm/dd/yyyy" or "m/dd/yyyy"
  if (/([0-1]?\d\/{1})([0-3]?\d\/{1})([12]{1}\d{3})/.test(date)) {
    const parts = date.split("/").map((p) => parseInt(p, 10));
    parts[0] -= 1;
    const d = new Date(parts[2], parts[0], parts[1]);
    return (
      d.getMonth() === parts[0] &&
      d.getDate() === parts[1] &&
      d.getFullYear() === parts[2]
    );
  }

  // Else, assumes date format is "yyyy-mm-dd"
  if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    const parts = date.split("-").map((p) => parseInt(p, 10));
    const d = new Date(parts[0], parts[1] - 1, parts[2]);

    return (
      d.getFullYear() === parts[0] &&
      d.getMonth() === parts[1] - 1 &&
      d.getDate() === parts[2]
    );
  }

  return false;
}

export function isValidDate(date) {
  if (date === null || date === "" || date === "-") return false;

  const formattedDate = new Date(date);
  return (
    date &&
    isDateValidFormat(date) &&
    formattedDate.toString() !== "Invalid Date" &&
    !isNaN(formattedDate)
  );
}

export const formatDateAsMMDDYYYY = (dateString) => {
  if (!dateString || !isValidDate(dateString)) return "";

  const date = new Date(dateString.replace(/-/g, "/"));

  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();

  if (day < 10) day = `0${day}`;
  if (month < 10) month = `0${month}`;

  return `${month}/${day}/${year}`;
};

export const limitDecimal = (val, precision) => {
  return Intl.NumberFormat("en-US", {
    maximumFractionDigits: precision,
    minimumFractionDigits: precision,
  }).format(val);
};

export const toDollar = (price) =>
  Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
  }).format(price);

export const getOutputType = (data) => {
  const reportType = data.Cover["Report Type"]?.toLowerCase();
  const assetType = data?.Cover?.["Asset Type"]?.toLowerCase();
  return { reportType, assetType };
};

export const isValidOutputType = (data) => {
  const { reportType, assetType } = getOutputType(data);
  return reportType && assetType;
};
